<template>
  <v-dialog
    v-model="showDialog"
    scrollable
    max-width="1000px"
    v-on:change="dialogClose()"
  >
    <v-card>
      <v-card-title>
        <!--search section-->
        <v-layout wrap>
          <v-flex xs12 sm6 md3>
            <v-text-field
              name="issueNo"
              label="Issue No"
              v-model="queryParams.issueNo"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch"
              >Search<v-icon right>search</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="accountPayableList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td @click="setAccountPayable(props.item)">
                  <a>{{ props.item.issueNo }}</a>
                </td>
                <td>
                  {{
                    props.item.createdDateInMilliSeconds | format-ms-date
                  }}
                </td>
                <td>{{ props.item.currencyCode }}</td>
                <td style="text-align: right">
                  {{ props.item.exchangeRateMMK | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ props.item.cashAmount | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ props.item.paidAmount | decFormat(6) }}
                </td>
                <td style="text-align: right">
                  {{ props.item.remainingAmount | decFormat(6) }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { AccountPayable } from "../../../models/model";
import { commonService } from "../../../services/common-service";
import { accountPayableService } from "../../../services/account-payable-service";

export default {
  props: [
    "showAdvancedAPListDialog",
    "fromDate",
    "toDate",
    "supplierId",
    "currencyId",
    "shopId",
  ],
  data: () => ({
    showListLoading: false,
    showDialog: false,
    accountPayableList: [],
    accountPayable: new AccountPayable(),
    headers: [
      { text: "Issue No",  align: "left", value: "issue_no" },
      { text: "Created Date", align: "left", value: "created_date" },
      { text: "Currency", value: "c.code" },
      { text: "Exchange Rate", value: "exchange_rate_mmk" },
      { text: "Total Advanced Amount", sortable: false },
      { text: "Advanced Used Amount", sortable: false },
      { text: "Total Remaining Amount", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "issue_no",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      supplierId: "",
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      shopId: "",
      currencyId: "",
    },
    decimalFormat: "",
  }),
  watch: {
    showAdvancedAPListDialog: function () {
      this.showDialog = !this.showDialog;
      this.onSearch();
    },
    pagination: {
      handler() {
        this.getSupplierAdvancedTypeAccountPayableList();
      },
      deep: true,
    },
  },
  created() {
    this.onSearch();
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      if (this.supplierId) {
        this.queryParams.supplierId = this.supplierId;
      }
      if (this.fromDate) {
        this.queryParams.fromDate = this.fromDate;
      }
      if (this.toDate) {
        this.queryParams.toDate = this.toDate;
      }
      if (this.shopId) {
        this.queryParams.shopId = this.shopId;
      }
      this.queryParams.currencyId = "";
      if (this.currencyId) {
        this.queryParams.currencyId = this.currencyId;
      }
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getSupplierAdvancedTypeAccountPayableList();
    },
    getSupplierAdvancedTypeAccountPayableList() {
      this.accountPayableList = [];
      if (this.queryParams.supplierId && this.queryParams.currencyId) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";

        accountPayableService
          .getUnpaidSupplierAdvancedTypeAccountPayableList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            this.accountPayableList = res.data.accountPayableList;
            this.totalRows = res.data.totalElements;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    setAccountPayable(accountPayable) {
      this.accountPayable = accountPayable;
      this.$emit("changeAccountPayable", this.accountPayable);
    },
    dialogClose() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>
